import { StyleSheet } from 'react-native';

const ResourceBookImage = ({ style }) => {
  const oneX = require('./resource-book.jpg');
  const twoX = require('./resource-book@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={{ ...StyleSheet.flatten(style), objectFit: 'cover' }}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { ResourceBookImage };
